import { render, staticRenderFns } from "./Expanded.vue?vue&type=template&id=ed8a729e&scoped=true&"
import script from "./Expanded.vue?vue&type=script&lang=js&"
export * from "./Expanded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8a729e",
  null
  
)

export default component.exports